import { IGetAllDisciplinaItemsChecklistUseCase } from "../../../presentation/useCases/read/get_all_disciplina_items_checklist_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";
import { GetAllDisciplinaChecklistRequestModel, GetAllItemsDisciplinaChecklistDaoModel } from "../../models/disciplina_item_models";
import { DisciplinaItemChecklistLista } from "../../models/items_disciplina_checklist_lista";

/**
 * GetAllDisciplinaItemsChecklistUseCase
 */

export class GetAllDisciplinaItemsChecklistUseCase
  extends BasePaginatedUseCase<DisciplinaItemChecklistLista>
  implements IGetAllDisciplinaItemsChecklistUseCase
{
  constructor(private readonly repository: IProjetosRepository) {
    super();
  }

  async getAllDisciplinaItemsChecklist(idDisciplinaChecklist: number, page: number, rowsPerPage: number): Promise<void> {
    const response = await this.repository.getAllDisciplinaItemsChecklist(idDisciplinaChecklist, page, rowsPerPage);

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
